<template>
  <Menubar class="" :model="items">
    <template #start>
      <img :src="logoSrc" alt="Logo" height="30" class="h-12 mr-2 backlight" />
    </template>
    <template #end>
      <Button icon="pi pi-sun" class="mr-2" severity="secondary" text @click="toggleTheme" />
      <Button v-if="isLogged" label="Logout" icon="pi pi-sign-out" @click="logout" class="p-button-text" />
    </template>
  </Menubar>
</template>

<script>
import { ref, computed, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import Menubar from 'primevue/menubar';
import Button from 'primevue/button';

export default {
  components: { Menubar, Button },
  setup() {
    const router = useRouter();
    const store = useStore();

    // Get user data from store
    const user = computed(() => store.state.users.user);
    const isLogged = computed(() => store.state.users.user.isLogged);
    const isAdmin = computed(() => store.state.users.user.type === 1);

    const items = computed(() => {
      const menu = [
        {
          label: 'Drivers',
          icon: 'pi pi-fw pi-truck',
          command: () => router.push('/drivers'),
          visible: isLogged.value
        },
        ...(isAdmin.value
            ? [
              {
                label: 'Dispatchers',
                icon: 'pi pi-fw pi-users',
                command: () => router.push('/users'),
              },
              {
                label: 'Admins',
                icon: 'pi pi-fw pi-user-plus',
                command: () => router.push('/admins'),
              }
            ]
            : []),
        {
          label: 'Account',
          icon: 'pi pi-fw pi-user',
          command: () => router.push('/account'),
          visible: isLogged.value
        }
      ];

      return menu;
    });

    const logout = () => {
      store.dispatch('users/logoutUser'); // Dispatch logout action
      router.push('/');
    };

    const logoSrc = computed(() => {
      return store.state.isTheme === 'dark' ? require('@/assets/cargo_status_icon.svg') : require('@/assets/cargo_status_icon.svg');
    });

    const toggleTheme = () => {
      const currentTheme = document.documentElement.classList.contains("dark-mode") ? "dark" : "light";
      const newTheme = currentTheme === "dark" ? "light" : "dark";
      document.documentElement.classList.toggle("dark-mode");
      store.dispatch('changeTheme', newTheme);
    };

    return {items, isLogged, logout, logoSrc, toggleTheme};
  },
};
</script>

<style>
.mr-2 {
  margin-right: 0.5rem;
}

.backlight:after {
  content: '';
  width: 100%;
  height: 100%;
  top: 0;
  left: 0px;
  position: absolute;
  background: inherit;
  filter: blur(7px);
  z-index: 0;
  opacity: 1;
}
</style>
